export default __webpack_public_path__ + "static/media/back_arrow.30d8769e.svg";